export const HighlightTextAtom = (props: any) => {
  return <span className="bg-yellow-300">{props.children}</span>;
};
